var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.$t("scrap-agent.drive.modal-access"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleModalClose()
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-mode" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src: "https://upload.wikimedia.org/wikipedia/commons/d/da/Google_Drive_logo.png",
                              alt: "Naver blog",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Google Drive")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("scrap-agent.allow-access.everything")
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch1d",
                                  value: "GG_DRIVE_CLOUD_STORAGE_ALL",
                                },
                                domProps: { checked: _vm.formData.all },
                                on: {
                                  change: function ($event) {
                                    _vm.formData.all = !_vm.formData.all
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch1d" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "dl",
                        { staticClass: "go-block-between" },
                        [
                          _c("dt", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.allow-access.datatype")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("MultiSelect", {
                            attrs: {
                              options: _vm.options,
                              disable: _vm.formData.all,
                              placeholder: _vm.$t(
                                "scrap-agent.allow-access.select-datatype"
                              ),
                            },
                            model: {
                              value: _vm.selectedDataTypes,
                              callback: function ($$v) {
                                _vm.selectedDataTypes = $$v
                              },
                              expression: "selectedDataTypes",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedDataTypes &&
                      _vm.selectedDataTypes.some(function (s) {
                        return s == "SPECIFIC_FOLDER"
                      })
                        ? _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("div", { staticClass: "go-block-between" }, [
                                _c("label", { staticClass: "go-form-label" }, [
                                  _vm._v("Input URL Folder"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-input-group-append" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn go-btn-outline-primary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addUrlFolder()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-18 go-icon-plus",
                                        }),
                                        _vm._v(
                                          "\n                      Add\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.formData.urlFolder,
                                function (url, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "go-input-group mb-1",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.formData.urlFolder[index],
                                            expression:
                                              "formData.urlFolder[index]",
                                          },
                                        ],
                                        staticClass: "go-form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Enter URL...",
                                        },
                                        domProps: {
                                          value: _vm.formData.urlFolder[index],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData.urlFolder,
                                              index,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedDataTypes &&
                      _vm.selectedDataTypes.some(function (s) {
                        return s == "SPECIFIC_FILE"
                      })
                        ? _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("div", { staticClass: "go-block-between" }, [
                                _c("label", { staticClass: "go-form-label" }, [
                                  _vm._v("Input URL File"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-input-group-append" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn go-btn-outline-primary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addUrlFile()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-18 go-icon-plus",
                                        }),
                                        _vm._v(
                                          "\n                      Add\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.formData.urlFile,
                                function (url, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "go-input-group mb-1",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.urlFile[index],
                                            expression:
                                              "formData.urlFile[index]",
                                          },
                                        ],
                                        staticClass: "go-form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Enter URL...",
                                        },
                                        domProps: {
                                          value: _vm.formData.urlFile[index],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData.urlFile,
                                              index,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleModalClose()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("scrap-agent.back")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      staticStyle: { "white-space": "nowrap" },
                      attrs: { type: "button", disabled: _vm.isDisable },
                      on: { click: _vm.handleAccessToken },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("scrap-agent.confirm")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }